import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/reevesdotnl/reevesdotnl/src/templates/pdf-view.tsx";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PublishDate = makeShortcode("PublishDate");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`The work of refining the model of Gondwana break-up and dispersion is on-going.
New, improved  data for the magnetic isochrons in the Indian Ocean greatly
reduce the level of uncertainty in the  paleo-positions of Antarctica and
Madagascar against Africa. This, in turn, reduces the uncertainty  in the
position of India once it was able to move independently of either Antarctica or
Madagascar.  The most recent model is used in the new animation on the
`}<a parentName="p" {...{
        "href": "/reevesdotnl/gondwana"
      }}>{`Gondwana`}</a>{` page of this website. `}</p>
    <p>{`The earliest independent motion of India (at the beginning of the Cretaceous) is
now concluded to  have been mostly away from Antarctica, though the failure
until now to recognise magnetic  isochrons reliably in the resulting ocean means
this cannot be confirmed directly. The outbreak of  the Kerguelen mantle plume
at the triple junction of (Greater) India, Australia and Antarctica led  to a
new ocean propagating westward as far as the present-day Krishna-Godavari delta
on India's  east coast and then diverting south between India and Sri
Lanka-Antarctica. Significant initial  growth of this ocean, in the present
model, is confined to a period of about 10 myr before M0 time  - the start of
the Cretaceous Quiet Zone - at 126.15 Ma. The figure below shows geological data
from an early version of the IGCP-628 Gondwana geological map in the
configuration we propose  for Valanginian time. `}</p>
    <PublishDate mdxType="PublishDate" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      